<template>
    <div class="image-card">
        <div class="card">

            <slot name="header">
                <div class="card-header" v-html="header"></div>
            </slot>

            <div class="card-body d-flex flex-column">
                <slot name="body">

                    <!-- <div class="d-flex align-items-center justify-content-between pb-2 mb-1 border-bottom-1 border-bottom">
                        <span v-for="(item, iindex) in columns" :key="iindex" class="fw-bold">{{ item }}</span>
                    </div>

                    <ul v-if="items.length" class="list-none p-0 m-0">
                        <li v-for="(item, iindex) in items" :key="iindex" class="d-flex align-items-center justify-content-between py-1">
                            <span>{{ item.title }}</span>
                            <div class="p-avatar-group p-component w-8rem justify-content-evenly">
                                <div v-for="(image, pindex) in item.images" :key="pindex" class="p-avatar p-component p-avatar-image p-avatar-circle">
                                    <img :src="image" />
                                </div>
                            </div>
                        </li>
                    </ul> -->


                    <ul class="list-none p-0 m-0">
                        <li class="d-flex mb-3">
                            <div class="d-flex flex-column align-items-center">
                                <span class="d-flex align-items-center justify-content-center border-circle p-2 p-avatar p-avatar-circle bg-primary bg-opacity-25 text-primary"><i class="fab fa-twitter"></i></span>
                                <div class="h-full bg-primary bg-opacity-25" style="width: 2px; min-height: 4rem;"></div>
                            </div>
                            <div class="ms-3 w-full">
                                <div class="d-flex align-items-center justify-content-between mb-3">
                                    <span>
                                        <strong>Tom Mathias</strong> retweeted a tweet about your following keyword.
                                    </span>
                                    <span class="fw-bold text-secondary">46m</span>
                                </div>
                                <div class="p-3 border-round" style="background-color: rgba(227, 248, 255, 0.5);">
                                    <div class="d-flex align-items-center justify-content-between mb-2">
                                        <img src="https://verona.primevue.org/demo/images/avatar/xuxuefeng.png" alt="avatar" class="w-2rem">
                                        <div class="p-avatar-group p-component" data-pc-name="avatargroup" data-pc-section="root">
                                            <div class="p-avatar p-component p-avatar-image p-avatar-circle" data-pc-name="avatar" data-pc-section="root">
                                                <img src="https://verona.primevue.org/demo/images/avatar/amyelsner.png" data-pc-section="image">
                                            </div>
                                            <div class="p-avatar p-component p-avatar-image p-avatar-circle" data-pc-name="avatar" data-pc-section="root">
                                                <img src="https://verona.primevue.org/demo/images/avatar/asiyajavayant.png" data-pc-section="image">
                                            </div>
                                            <div class="p-avatar p-component p-avatar-image p-avatar-circle" data-pc-name="avatar" data-pc-section="root">
                                                <img src="https://verona.primevue.org/demo/images/avatar/onyamalimba.png" data-pc-section="image">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="fw-bold mb-2">Jeff Atwood</div>
                                    <p class="text-secondary text-sm line-height-3 mb-3" style="max-width: 28rem;">Hooray! I suck at hardware but I was able to get the pi zero W, plus usb case, plus two color e-ink hat, to work!</p>
                                    <div role="progressbar" class="p-progressbar p-component p-progressbar-determinate w-full md:w-6" aria-valuemin="0" aria-valuenow="50" aria-valuemax="100" data-pc-name="progressbar" data-pc-section="root" style="height: 0.5rem;">
                                        <div class="p-progressbar-value p-progressbar-value-animate" style="width: 50%; display: flex;" data-pc-section="value"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="d-flex mb-3">
                            <div class="d-flex flex-column align-items-center">
                                <span class="d-flex align-items-center justify-content-center border-circle p-2 p-avatar p-avatar-circle bg-warning bg-opacity-25 text-warning"><i class="fas fa-star"></i></span>
                                <div class="h-full bg-warning bg-opacity-25" style="width:2px;min-height:4rem;"></div>
                            </div>
                            <div class="ms-3 w-full">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span><strong>Scott Wesley</strong> starred NS0021 on customer list.</span>
                                    <span class="fw-bold text-secondary">1h 51m</span>
                                </div>
                            </div>
                        </li>
                        <li class="d-flex mb-3">
                            <div class="d-flex flex-column align-items-center">
                                <span class="d-flex align-items-center justify-content-center border-circle p-2 p-avatar p-avatar-circle bg-success bg-opacity-25 text-success"><i class="fas fa-link"></i></span>
                                <div class="h-full bg-success bg-opacity-25" style="width:2px;min-height:4rem;"></div>
                            </div>
                            <div class="ms-3 w-full">
                                <div class="d-flex align-items-center justify-content-between mb-3">
                                    <span><strong>Jorge Gomez</strong> shared design files on cloud. </span>
                                    <span class="fw-bold text-secondary">12h</span>
                                </div>
                                <ul class="list-none p-0 m-0">
                                    <li class="d-flex align-items-center justify-content-start mb-2">
                                        <img src="https://verona.primevue.org/demo/images/dashboard/bg-detail.svg" alt="bg" class="w-2rem">
                                        <span class="fw-bold ms-2">01.Verona-Remastered.fig</span>
                                    </li>

                                    <li class="d-flex align-items-center justify-content-start">
                                        <img src="https://verona.primevue.org/demo/images/dashboard/bg-detail.svg" alt="bg" class="w-2rem">
                                        <span class="fw-bold ms-2">02.Verona-Marketing.fig</span>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="text-center">
                            <button class="p-button p-component p-button-text" type="button" aria-label="View More" data-pc-name="button" data-pc-section="root" data-pd-ripple="true">
                                <span class="p-button-icon p-button-icon-left fas fa-chevron-down" data-pc-section="icon"></span>
                                <span class="p-button-label" data-pc-section="label">View More</span>
                                <span role="presentation" aria-hidden="true" data-p-ink="true" data-p-ink-active="false" class="p-ink" data-pc-name="ripple" data-pc-section="root"></span>
                            </button>
                        </li>
                    </ul>

                </slot>
            </div>

            <slot name="footer">
                <div class="card-footer" v-html="footer"></div>
            </slot>

        </div>
    </div>
</template>


<script>
    export default {
        name: "TimelineCard",
        props: {
            header: {
                type: String,
                default: "",
            },
            image: {
                type: String,
                default: "",
            },
            columns: {
                type: Array,
                default() {
                    return [];
                },
            },
            items: {
                type: Array,
                default() {
                    return [];
                },
            },
            footer: {
                type: String,
                default: "",
            },
        },
        setup() {
            return {};
        },
    };
</script>


<style lang="scss">
    .image-card {
        width: 100%;
        height: 100%;

        a {
            text-decoration: underline;
        }

        .list-none {
            list-style: none;
        }

        .card {
            border: 0px;
            border-radius: 10px;
            padding: 10px;
            height: 100%;
            width: 100%;
        }
        .card-header {
            background-color: unset;
            border: 0px;
            font-size: 1rem;
            font-weight: 600;
        }
        .card-footer {
            background-color: unset;
            border: 0px;
        }
    }
</style>